module.exports = __webpack_public_path__ + "static/media/pdo02.0d852cdc.jpg";